var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounArrow3134209(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-arrow-3134209 1",
    clipPath: "url(#clip0_457_749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 7.5e-05C11.0218 7.5e-05 7.2065 1.58045 4.39325 4.39333C1.58025 7.20633 0 11.0218 0 15.0001C0 18.9783 1.58037 22.7936 4.39325 25.6068C7.20625 28.4198 11.0218 30.0001 15 30.0001C17.633 30.0001 20.2197 29.307 22.5 27.9905C24.7803 26.6739 26.6737 24.7803 27.9905 22.5C29.307 20.2197 30.0001 17.633 30.0001 15C30.0001 11.0218 28.4197 7.2065 25.6068 4.39325C22.7938 1.58025 18.9783 0 15.0001 0L15 7.5e-05ZM22.5 15.0301C22.5051 15.3562 22.3773 15.6702 22.146 15.9001L17.208 20.8231C16.903 21.1285 16.4583 21.2481 16.0413 21.1368C15.6243 21.0254 15.2984 20.7001 15.1863 20.2833C15.0743 19.8665 15.1931 19.4215 15.498 19.116L18.3901 16.2211H8.70005C8.27135 16.2211 7.87515 15.9923 7.6608 15.621C7.44645 15.2498 7.44645 14.7923 7.6608 14.4211C7.87516 14.0497 8.27135 13.821 8.70005 13.821H18.4171L15.498 10.9021H15.4981C15.1927 10.5967 15.0733 10.1514 15.1851 9.73418C15.297 9.3169 15.6228 8.99092 16.0401 8.8791C16.4574 8.76738 16.9026 8.88662 17.2081 9.1921L22.1461 14.1151C22.3736 14.3413 22.5012 14.6492 22.5001 14.9701L22.5 15.0301Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounArrow3134209);
export default __webpack_public_path__ + "static/media/noun-arrow-3134209.d0ad1ad69501805e144b6bff8ea9c1c9.svg";
export { ForwardRef as ReactComponent };